import axios from 'axios'
import { GenericOrderBy } from '../../components/_EOS/Table'
import { Filter } from '../../components/_WMS/FilterComponent'
import { ApiConfig } from '../../config/api'
import { ProductOrigin } from '../../interfaces/Producto/ProductOrigins'

const getProductsOrigins = (
  filter: Filter[],
  orderBy: GenericOrderBy<ProductOrigin>,
  page = 0,
  pageSize = 5
) => {
  const url = new URL(`${ApiConfig.ProductOriginApi}`)

  filter.forEach((el) => {
    url.searchParams.set(el.key, el.value)
  })

  url.searchParams.set('pageIndex', page.toString())
  url.searchParams.set('pageSize', pageSize.toString())

  if (orderBy) {
    url.searchParams.set(
      'sorters',
      JSON.stringify({ datafield: orderBy.field, sortOrder: orderBy.direction })
    )
  }

  return axios.get(url.toString())
}

const patchProductOrigin = (
  productOriginId: number,
  productOrigin: ProductOrigin
) => {
  const url = new URL(`${ApiConfig.ProductOriginApi}/${productOriginId}`)

  const filteredOrderOrigins = productOrigin.orderOriginIds?.filter(
    (el) => el > 0
  )

  const body: ProductOrigin = {
    ...productOrigin,
    orderOriginIds: filteredOrderOrigins
  }

  return axios.patch(url.toString(), body)
}

const postProductOrigin = (productOrigin: ProductOrigin) => {
  const url = new URL(`${ApiConfig.ProductOriginApi}`)

  const filteredOrderOrigins = productOrigin.orderOriginIds?.filter(
    (el) => el > 0
  )

  const body: ProductOrigin = {
    ...productOrigin,
    orderOriginIds: filteredOrderOrigins
  }

  return axios.post(url.toString(), body)
}

const getTypeOperationWarehouse = (
  typeStorageId: number,
  productOriginId?: number
) => {
  const url = new URL(
    `${ApiConfig.TypeOperationApi}/${typeStorageId}/Warehouse`
  )

  if (productOriginId)
    url.searchParams.set('producOriginId', productOriginId.toString())

  return axios.get(url.toString())
}

export {
  getProductsOrigins,
  patchProductOrigin,
  postProductOrigin,
  getTypeOperationWarehouse
}
